import { Link } from "react-router-dom";
import type { Category } from "@/types/api";
import { resolveCategoryColor } from "@/lib/categoryColors";
import { cn } from "@/lib/utils";

interface CategoryPillProps {
  category: Pick<Category, "name" | "slug" | "color">;
  className?: string;
  asLink?: boolean;
}

export function CategoryPill({ category, className, asLink = true }: CategoryPillProps) {
  const color = resolveCategoryColor(category.slug, category.color);

  const pill = (
    <span
      className={cn(
        "inline-flex items-center rounded-badge px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-white",
        className,
      )}
      style={{ backgroundColor: color }}
    >
      {category.name}
    </span>
  );

  if (!asLink) return pill;
  return <Link to={`/categoria/${category.slug}`}>{pill}</Link>;
}
